import { Item } from './model';
import { ItemDefault } from './defaults';
import { HistoryEventDto, HistoryEventTKeys } from '.';
import { AppKeys, newMsg, newTag } from '../../../core/localization';
import * as Devices from '../../devices';
import { areEqualILog, AreEqualILog, MapLog } from '../../historical';

export const msgHeader = newMsg(AppKeys.DeviceInfo_Header);
export const msgFetching = newMsg(AppKeys.Com_Loading);
export const msgChecking = newMsg(AppKeys.DeviceLogs_Checking);
export const msgLogsLink = newMsg(AppKeys.DeviceLogs_Header);
export const msgLogsHeader = newMsg(AppKeys.DeviceLogs_Header);
export const msgMoreLogsBtn = newMsg(AppKeys.DeviceLogs_LoadMore_Btn);
export const msgNoLogs = newMsg(AppKeys.DeviceLogs_NoLogs);

export const msgDeviceInfoError = (device: Devices.PKey) =>
  newMsg(AppKeys.ApiMykeys_GetDeviceInfo_Error, [
    newTag('devicePK', Devices.getPK(device)),
  ]);

export const itemByDevice = (device: Devices.Device) => ({
  ...ItemDefault(device),
  ...device,
});
export const findItem = (items: Item[], key: Devices.PKey) =>
  Devices.getItemByPK(items, Devices.getPK(key));
export const extendItem = (item: Item, extension: Devices.DeviceExtension) => ({
  ...item,
  ...Devices.DeviceExtensionMap(extension),
});

export const getEventKey = (eventCode: HistoryEventDto) => {
  const eventKeys: { [x: number]: string } = HistoryEventTKeys;
  return eventKeys[eventCode];
};

export const areEqual: AreEqualILog<Devices.Log> = (a, b) =>
  areEqualILog(a, b) &&
  a.eventMessage === b.eventMessage &&
  a.userName === b.userName &&
  a.customerName === b.customerName;

const getExecuter = (l: Devices.Log) => 
  `${l.userName.startsWith('client_') ? 'M2M' : l.userName} - ${l.customerName}`;

export const mapLog: MapLog<Devices.Log> = (l) => {
  return {
    date: new Date(l.datetime),
    title: getEventKey(l.eventMessage),
    subtitle: getExecuter(l),
  };

  
};
